// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"34939c77008d3096","6325":"4d3ec48a040c7e6a"}[chunkId] + ".css";
};